import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex h-screen flex-col items-center justify-center px-4 text-center">
      <h1 className="pointer-events-none absolute bottom-0 select-none font-heading text-9xl font-black text-background-100 md:text-[12rem]">
        404
      </h1>
      <div className="relative z-10 flex flex-col items-center">
        <p className="text-xl font-semibold text-foreground-950 md:text-2xl">
          This page has not been generated
        </p>
        <p className="mt-2 text-base text-foreground-500">{location.pathname}</p>
        <Link
          to="/"
          className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
        >
          <span className="flex h-5 w-5 items-center justify-center">
            <i className="ri-arrow-left-line text-lg"></i>
          </span>
          Back to homepage
        </Link>
      </div>
    </div>
  );
}